<svg
  [attr.width]="width()"
  [attr.height]="height()"
  [attr.viewBox]="customViewBox()"
  xmlns="http://www.w3.org/2000/svg"
  [innerHTML]="icon"
  class="base-icon"
  role="img"
></svg>
